import { createFileRoute } from "@tanstack/react-router";
import NCPumaModel from "@/pages/NCPumaModel";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/nc-puma-dealer/$slug")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/nc-puma-dealer/:slug' }),
  component: NCPumaModel,
});
